import { render, staticRenderFns } from "./ProductDetailsCardOldUI.vue?vue&type=template&id=33df9901&scoped=true&"
import script from "./ProductDetailsCardOldUI.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsCardOldUI.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailsCardOldUI.vue?vue&type=style&index=0&id=33df9901&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33df9901",
  null
  
)

export default component.exports